export default "__VITE_ASSET__CnyM2yVv__"